import React from 'react'
import FlightItem from '../search/FlightItem'
import DomesticFlightItem from './DomesticFlightItem'

const DomesticItineraryInfo = ({ flight }) => {
  return (
    <div className=''>
      <DomesticFlightItem
        key={"1st"}
        fd={flight}
        type={"departure"}
        isFirstIndex={true}
      />
      <DomesticFlightItem
        key={"2nd"}
        fd={flight}
        type={"landing"}
        isLastIndex={true}
      />
    </div>
  )
}

export default DomesticItineraryInfo
